import { Icon, SVG } from './template';

export const Multiply = Icon(({ size = 8, width = size, height = size, ...props }, ref) => (
    <SVG {...props} width={width} height={height} ref={ref}>
        <path d="M7 1L1 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 7L1 1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </SVG>
));
